import Vue from 'vue';

export default {
  state: {
    documentsList: [],
  },
  mutations: {
    setDocumentsList(state, data) {
      state.documentsList = data;
    },
  },
  actions: {
    getDocumentsList(store) {
      const path = 'documents?_sort=date:desc';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setDocumentsList', resp.data);
        return resp.data;
      });
    },
  },
};
